import { useCallback, useRef, useState } from 'react';

/**
 * @template {*} U
 * @template {*} T
 *
 * Swap between states.
 *
 * Toggles between the two provided values.
 * The initial values will be memoized and will not update
 * if programmatically changed after initial call.
 *
 * @param {U} defaultState
 * @param {T} elevatedState
 * @return {[U | T, function(): void]}
 */
export default (defaultState = false, elevatedState = true): [boolean, () => void] => {
  const values = useRef([defaultState, elevatedState]);
  const [value, setValue] = useState(values.current[0]);

  const toggleValue = useCallback(() => setValue(values.current.reverse()[0]), [setValue, values]);
  return [value, toggleValue];
};
